import { createApp, nextTick } from 'vue';
import App from './App.vue';
import router from './router';
import 'animate.css'
// 这块一定要加,否者会有部分动画无法执行
import 'animate.css/animate.compat.css'
import WOW from 'wow.js';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/swiper-bundle.css'; // 导入 swiper 的 CSS 样式
// import { Swiper, SwiperSlide } from 'swiper/vue'; // 导入 Vue 组件


const app = createApp(App);

// app.component('Swiper', Swiper); // 注册 Swiper 组件
// app.component('SwiperSlide', SwiperSlide); // 注册 SwiperSlide 组件


app.use(router);
app.mount('#app');

nextTick(() => {
  const wow = new WOW({
    boxClass: "wow",
    animateClass: "animated",
    offset: 0,
    mobile: true,
    live: true,
    // callback: function(box) {
    //   console.log(box, 'box');
    // },
    scrollContainer: null,
    resetAnimation: true,
  });
  wow.init();
//   console.log('WOW.js initialized');
});